import React, { useState } from 'react';
import './AdminLogin.css';

/* ─── Hardcoded admin credentials ─── */
const ADMIN_ID = 'admin';
const ADMIN_PASS = 'admin123';

const AdminLogin = () => {
  const [adminId, setAdminId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Simulate a brief loading state for UX
    // Trim inputs to handle mobile keyboard trailing spaces
    setTimeout(() => {
      if (adminId.trim() === ADMIN_ID && password.trim() === ADMIN_PASS) {
        sessionStorage.setItem('adminAuthenticated', 'true');
        // Use full page navigation instead of React Router navigate()
        // to ensure redirect works reliably on all deployment environments
        window.location.href = '/admin';
      } else {
        setError('Invalid admin credentials. Access denied.');
        setShake(true);
        setTimeout(() => setShake(false), 600);
      }
      setLoading(false);
    }, 800);
  };

  return (
    <div className="admin-login-page">
      {/* Animated background */}
      <div className="admin-login-bg" />
      <div className="admin-login-particles">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="admin-particle" />
        ))}
      </div>

      {/* Login card */}
      <div className={`admin-login-card ${shake ? 'admin-login-shake' : ''}`}>
        {/* Brand */}
        <div className="admin-login-brand">
          <div className="admin-login-shield">🛡️</div>
          <h1>Admin Portal</h1>
          <p>Stocks4U Control Center</p>
        </div>

        {/* Form */}
        <form className="admin-login-form" onSubmit={handleSubmit}>
          <div className="admin-input-group">
            <label htmlFor="admin-id">Admin ID</label>
            <span className="admin-input-icon">👤</span>
            <input
              id="admin-id"
              type="text"
              placeholder="Enter admin ID"
              value={adminId}
              onChange={(e) => { setAdminId(e.target.value); setError(''); }}
              required
              autoComplete="off"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
            />
          </div>

          <div className="admin-input-group">
            <label htmlFor="admin-password">Password</label>
            <span className="admin-input-icon">🔒</span>
            <input
              id="admin-password"
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              required
              autoComplete="off"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
            />
            <button
              type="button"
              className="admin-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>

          {error && (
            <div className="admin-login-error">
              <span>⚠️</span>
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            className="admin-login-btn"
            disabled={loading}
          >
            <span className="admin-login-btn-content">
              {loading ? (
                <>
                  <div className="admin-btn-spinner" />
                  <span>Authenticating...</span>
                </>
              ) : (
                <>
                  <span>Access Dashboard</span>
                  <span>→</span>
                </>
              )}
            </span>
          </button>
        </form>

        {/* Footer */}
        <div className="admin-login-footer">
          <p>
            Authorized personnel only · <a href="/">Back to site</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
